import { EPublishPeriod } from '../../../../api-models/common/json_query';

export const PUBLISH_PERIOD_MAP_VALUE_TO_LABEL = {
  [EPublishPeriod.Today]: 'сегодня',
  [EPublishPeriod.Hour]: 'за час',
  [EPublishPeriod.Day]: 'за сутки',
  [EPublishPeriod.Week]: 'за неделю',
  [EPublishPeriod.TenDays]: 'за 10 дней',
  [EPublishPeriod.Month]: 'за месяц',
};
